module.exports = __webpack_public_path__ + "static/media/arrowRight.cee4d29c.svg";